import React, { Component } from "react";
import { Redirect } from 'react-router-dom';
import { Modal, Button, Form, Alert } from "react-bootstrap";
import moment from 'moment';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { validateJobForm } from "../utils/validation";
import CommonToast from "./Toaster/CommonToast";
import CommonLoader from "./loaderComponent/CommonLoader";


export default class JobAddModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: null,
      jobTitle: "",
      startDate: null,
      endDate: null,
      departments: [],
      users: [],
      selectedDepartment: '',
      selectedUser: '',
      showAlert: false,
      errorMsg: "",
      done: false,
      errors: {},
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: '',
      loading: false
    };
  }

  componentDidMount() {
    this.fetchDepartments();
  }

  fetchDepartments = () => {
    this.setState({ loading: true });
    axios({
      method: 'get',
      url: 'departments',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        this.setState({ departments: res.data, loading: false });
      });
  };

  fetchUsers = () => {
    this.setState({ loading: true });
    let users = [];
    this.state.departments.map(dept => {
      console.log(dept.id, this.state.selectedDepartment);
      if (dept.id == this.state.selectedDepartment) {
        dept.users.map((user, index) => {
          users.push(user);
        });
        this.setState({ users: users, loading: false });
      }
    });
  };

  handleChange = (event) => {
    const { value, name } = event.target;
    this.setState({
      [name]: value,
    });
  };

  // onDepartmentChange = (event) => {
  //   this.setState({ selectedDepartment: event.target.value }, () => {
  //     this.fetchUsers()
  //   })
  // }

  onDepartmentChange = (event) => {
    const selectedDepartment = event.target.value;
    let errors = { ...this.state.errors };
    if (!selectedDepartment) {
      errors.selectedDepartment = "Please select a department.";
    } else {
      delete errors.selectedDepartment;
    }

    this.setState({ selectedDepartment, errors }, () => {
      if (selectedDepartment) {
        this.fetchUsers();
      }
    });
  };


  onUserChange = (event) => {
    // this.setState({ selectedUser: event.target.value })
    const selectedUser = event.target.value;
    let errors = { ...this.state.errors };
    if (!selectedUser) {
      errors.selectedUser = "Please select a user.";
    } else {
      delete errors.selectedUser;
    }

    this.setState({
      selectedUser,
      errors
    });
  };

  pushDepartments = () => {
    let items = [];
    this.state.departments.map((dept, index) => {
      items.push(<option key={index} value={dept.id}>{dept.departmentName}</option>);
    });
    return items;
  };

  pushUsers = () => {
    let items = [];
    this.state.users.map((user, index) => {
      items.push(<option key={index} value={user.id}>{user.fullName}</option>);
    });
    return items;
  };

  handleDateChange = (date, field) => {
    let errors = { ...this.state.errors };

    if (field === "startDate") {
      this.setState({
        startDate: date,
        targetDate: date,
        endDate: null,
        errors: { ...errors, startDate: undefined },
      });
    }

    if (field === "endDate") {
      if (date < this.state.targetDate) {
        errors.endDate = "End date must be on or after start date.";
      } else {
        delete errors.endDate;
      }

      this.setState({
        endDate: date,
        errors,
      });
    }
  };


  onSubmit = (e) => {
    this.setState({ loading: true });
    e.preventDefault();
    const errors = validateJobForm(
      this.state.jobTitle,
      this.state.selectedUser,
      this.state.selectedDepartment,
      this.state.startDate,
      this.state.endDate
    );
    let job = {
      jobTitle: this.state.jobTitle,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      userId: this.state.selectedUser
    };
    if (Object.keys(errors).length > 0) {
      this.setState({ errors, loading: false });
      return;
    }

    axios({
      method: 'post',
      url: `/jobs`,
      data: job,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        this.setState({
          completed: true,
          toastMessage: "Job created successfully!",
          toastVariant: 'success',
          color: 'green',
          done: true,
          showToast: true,
        });
        setTimeout(() => {
          this.setState({ loading: false, showToast: false });
        }, 1000);
      })
      .catch(err => {
        this.setState({
          completed: true,
          toastMessage: err.response.data.message,
          toastVariant: 'danger',
          color: 'red',
          done: true,
          showToast: true,
        });
        setTimeout(() => {
          this.setState({ loading: false, showToast: false });
          this.props.onHide();
        }, 2000);

      });
  };

  render() {

    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <CommonLoader isLoading={this.state.loading}>

          <Modal
            {...this.props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                Add Job
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form onSubmit={this.onSubmit}>
                <Form.Group>
                  <Form.Label className="mb-2 required">Select Department</Form.Label>
                  <Form.Control
                    as="select"
                    className="form-select"
                    value={this.state.selectedDepartment || ""}
                    onChange={this.onDepartmentChange}
                  >
                    <option value="">Choose one department...</option>
                    {this.pushDepartments()}
                  </Form.Control>
                  <span className="login-error">
                    {this.state.errors.selectedDepartment && <small className="text-danger">{this.state.errors.selectedDepartment}</small>}
                  </span>
                </Form.Group>
                {this.state.selectedDepartment ? (
                  <Form.Group>
                    <Form.Label className="mb-2 required">Select User</Form.Label>
                    <Form.Control
                      as="select"
                      className="form-select"
                      value={this.state.selectedUser || ''}
                      onChange={this.onUserChange}
                    >
                      <option value="">Choose one...</option>
                      {this.pushUsers()}
                    </Form.Control>
                    <span className="login-error">
                      {this.state.errors.selectedUser && <small className="text-danger">{this.state.errors.selectedUser}</small>}
                    </span>
                  </Form.Group>

                ) : null}
                {/* {
                  done ? <Redirect to={{ pathname: '/job-list', state: { selectedDepartment: this.state.departmentId } }} /> : <></>}
                {showAlert ? (
                  <Alert variant="alert alert-warning" className="m-1">
                    {this.state.errorMsg}
                  </Alert>) : (<></>)
                } */}
                <Form.Group controlId="formJobTitle">
                  <Form.Label className="mb-2 required">Job Title</Form.Label>
                  <Form.Control
                    type="text"
                    className="col-12"
                    name="jobTitle"
                    placeholder="Enter job title"
                    value={this.state.jobTitle}
                    onChange={this.handleChange}
                    autoComplete="off"
                  />
                </Form.Group>
                <span className="login-error">
                  {this.state.errors.jobTitle && <small className="text-danger">{this.state.errors.jobTitle}</small>}
                </span>
                <Form.Group controlId="formStartDate">
                  <Form.Label className="mb-2 required d-block">Job start date</Form.Label>
                  <DatePicker
                    selected={this.state.startDate}
                    className="form-control "
                    dateFormat="dd/MM/yyyy"
                    onChange={date => this.handleDateChange(date, 'startDate')}
                    placeholderText="Select start date"
                    minDate={new Date(new Date().getFullYear(), new Date().getMonth(), 1)}
                  />
                  <span className="login-error">
                    {this.state.errors.startDate && <small className="text-danger">{this.state.errors.startDate}</small>}
                  </span>
                </Form.Group>
                <Form.Group controlId="fromEndDate">
                  <Form.Label className="mb-2 required d-block">Job End Date</Form.Label>
                  {/* <DatePicker
                    selected={this.state.endDate}
                    onChange={endDate => this.setState({ endDate: endDate })}
                    minDate={Date.now()}
                    dateFormat="yyyy-MM-dd"
                    className="form-control ml-1"
                    placeholderText="Select Start Date"
                    autoComplete="off"
                    required
                  /> */}
                  <DatePicker
                    selected={this.state.endDate}
                    className="form-control"
                    onChange={date => this.handleDateChange(date, 'endDate')}
                    placeholderText="Select end date"
                    minDate={this.state.targetDate || this.state.startDate}
                    disabled={!this.state.startDate || !this.state.targetDate}
                    showMonthDropdown
                    dateFormat="dd/MM/yyyy"
                    showYearDropdown
                    dropdownMode="select"
                  />
                  <span className="login-error">
                    {this.state.errors.endDate && <small className="text-danger">{this.state.errors.endDate}</small>}
                  </span>
                </Form.Group>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                  <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" type="submit" >
                    Submit
                  </Button>
                  <Button variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel" onClick={this.props.onHide}>Close</Button>

                </div>

              </Form>
            </Modal.Body>

          </Modal>
        </CommonLoader>
      </>
    );
  }
}